import API from "../../../../../global/api";


export const requestAddFBRProduct = () => {
    return {
        type: "REQUEST_ADD_FBR_PRODUCT",
    };
};
export const successAddFBRProduct = (data) => {
    return {
        type: "SUCCESS_ADD_FBR_PRODUCT",
        payload: data,
    };
};
export const errorAddFBRProduct = () => {
    return {
        type: "ERROR_ADD_FBR_PRODUCT",
    };
};
export const AddFBRProductApi = (data, showSuccessAlert, showErrorAlert) => {
    return (dispatch) => {
        dispatch(requestAddFBRProduct());
        API.post(`/FBRInvoice/add-product`, data).then((res) => {
            dispatch(successAddFBRProduct(data));
            showSuccessAlert(res.data.message);
        }).catch((error) => {
            dispatch(errorAddFBRProduct());
            showErrorAlert(error.response.data.message || "Something went wrong");
        })
    };
};


export const requestGetFBRProduct = () => {
    return {
        type: "REQUEST_GET_FBR_PRODUCT",
    };
};
export const successGetFBRProduct = (data) => {
    return {
        type: "SUCCESS_GET_FBR_PRODUCT",
        payload: data,
    };
};
export const errorGetFBRProduct = () => {
    return {
        type: "ERROR_GET_FBR_PRODUCT",
    };
};
export const GetFBRProductApi = () => {
    return (dispatch) => {
        dispatch(requestGetFBRProduct());
        API.get(`/FBRInvoice/get-products?page=0&limit=1000`).then((res) => {
            let getData = res.data;
            dispatch(successGetFBRProduct(getData));
        }).catch((error) => {
            dispatch(errorGetFBRProduct());
        })
    };
};


export const DeleteRequestFBRProduct = () => {
    return {
        type: "DELETE_REQUEST_FBR_PRODUCT",
    };
};
export const DeleteSuccessFBRProduct = (productId) => {
    return {
        type: "DELETE_SUCCESS_FBR_PRODUCT",
        productId: productId,
    };
};
export const DeleteErrorFBRProduct = () => {
    return {
        type: "DELETE_ERROR_FBR_PRODUCT",
    };
};
export const DeleteFBRProductApi = (productId) => {
    return dispatch => {
        dispatch(DeleteRequestFBRProduct());
        API.delete(`/FBRInvoice/delete-product/${productId}`).then(res => {
            dispatch(DeleteSuccessFBRProduct(productId))
        }).catch((error) => {
            dispatch(DeleteErrorFBRProduct())
        });
    }
};